import React, { useCallback, useContext } from "react";
import PropTypes from "prop-types";

import TranslationContext from "../../../Context/Translation";

import CardListNewsListItem from "./CardListNewsListItem";

const CardListNewsList = ({ properties: { news, hideDate, animation } }) => {
  const { translation } = useContext(TranslationContext);

  const activeTranslation = translation.find((lang) => lang.active === 1);

  const renderNews = useCallback(() => {
    return news.map((newsItem) => {
      return (
        <CardListNewsListItem
          news={newsItem}
          key={`key_${newsItem.title || Math.random()}`}
          linkType={newsItem.linkType}
          linkTitle={
            newsItem.linkTitle ||
            (activeTranslation.twoLetterIsoCode === "de" ? "Weiterlesen" : "Read More")
          }
          hideDate={hideDate}
          animation={animation}
        />
      );
    });
  }, [news, activeTranslation, hideDate, animation]);

  return (
    <div className="container news-list card-list">
      {news.length > 0 && (
        <div
          className={`row 
                      row-cols-1 
                      g-4`.replace(/\n\s+/g, "")}
        >
          {renderNews()}
        </div>
      )}
    </div>
  );
};

CardListNewsList.propTypes = {
  properties: PropTypes.instanceOf(Object),
};

export default CardListNewsList;
